console.log("unpango js");

let option_selector = document.getElementsByClassName("option-selector");
let productContainers = document.getElementsByClassName("product-item");

// FUNCION QUE ASIGNA EL SELECT
function opcion_selected() {
  for (let i_opcion = 0; i_opcion < option_selector.length; i_opcion++) {
    let opcion = option_selector[i_opcion];

    let btnsVariante = opcion.getElementsByClassName("size-option");
    
    for (let i_btnV = 0; i_btnV < btnsVariante.length; i_btnV++) {
      let boton = btnsVariante[i_btnV];
      
      boton.addEventListener("click", () => {

        // ELIMINA LOS ESTILOS DE "SELECCIONADO" DE LOS BOTONES
        for (let i_btnV2 = 0; i_btnV2 < btnsVariante.length; i_btnV2++) {
          let boton_v2 = btnsVariante[i_btnV2];
          boton_v2.classList.remove("selected");
        }

        boton.classList.add("selected");
        // varianteId = boton.value;

      });
    }
  }
}

function get_id_variante(container_producto) {

  let full_title = "";

  for (let i1 = 0; i1 < productContainers.length; i1++) {    
    let producto_selectores = container_producto.getElementsByClassName("option-selector");

    for (let i2 = 0; i2 < producto_selectores.length; i2++) {
      let producto_selector = producto_selectores[i2]
      let btnsVariante = producto_selector.getElementsByClassName("size-option");

      for (let i3 = 0; i3 < btnsVariante.length; i3++) {
        let selector = btnsVariante[i3];
        if (selector.classList.contains("selected")) {
          let title = selector.getElementsByTagName("span")[0];
          full_title = full_title + " / " + title.textContent;
        }
      }
    }
    
    full_title = full_title.substring(3);

    let listados_variates = document.getElementsByClassName("upng_variantes_title_id")
    for (let j = 0; j < listados_variates.length; j++) {
      let listado = listados_variates[j];
      
      lis = listado.getElementsByTagName("li");
      for (let j2 = 0; j2 < lis.length; j2++) {
        let li = lis[j2];
        if (li.textContent == full_title) {
          return li.id;
        }
      }
    };
  }
}

function get_quantity(container) {
  let quantity_inputs = container.getElementsByClassName("qty-input__input");

  if (quantity_inputs.length == 0) {
    return 1;
  } else {

    let qi_plus = quantity_inputs[2];
    // let qi_value = quantity_inputs[1].value;
    let qi_value = quantity_inputs[1];
    let qi_minus = quantity_inputs[0];

    if (parseInt(qi_value.value) == 1) {  
      qi_minus.disabled = true;
      qi_minus.classList.add("disabled");
    } 

    qi_plus.addEventListener("click", () => {

      qi_value.value = parseInt(qi_value.value) + 1;

      qi_minus.disabled = false;
      qi_minus.classList.remove("disabled");

    });

    qi_minus.addEventListener("click", () => {

      qi_value.value = parseInt(qi_value.value) - 1;

      if (parseInt(qi_value.value) == 1) {
        qi_minus.disabled = true;
        qi_minus.classList.add("disabled");
      } 
    });
    return quantity_inputs[1].value;
  }
}

function add_to_cart(varianteId, quantity) {

  let formData = {
    'items': [{
      'id': varianteId,
      'quantity': quantity
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

for (let i_producto = 0; i_producto < productContainers.length; i_producto++) {

  let producto = productContainers[i_producto];

  get_quantity(producto);
  
  let varianteId = producto.getElementsByClassName("upng-variant-info")[0];
  let add_to_cart_btn = producto.getElementsByClassName("upng-add-to-cart-btn")[0];
  // let varianteId = producto.getElementsByClassName("upng-variant-info")[0];

  let btnsVariante = producto.getElementsByClassName("size-option");

  opcion_selected();
  
  // SOLO CUANDO SE TENGAN VARIANTES
  for (let i_btnV = 0; i_btnV < btnsVariante.length; i_btnV++) {
    let boton = btnsVariante[i_btnV];
    boton.addEventListener("click", () => {

      // SE QUEDA CON EL NUEVO ID
      varianteId = get_id_variante(producto);
      
      if (varianteId == undefined) {
        varianteId = producto.getElementsByClassName("upng-variant-info")[0];
      }
      
    });
  }

  add_to_cart_btn.addEventListener("click", () => {

    // En caso de que tengamos el html del botón, sacamos la id del "value"
    if (typeof(varianteId) != "string") {
      varianteId = varianteId.value;
    }

    // let quantity = producto.getElementsByClassName("qty-input__input")[1].value;
    
    let quantity = get_quantity(producto);

    // console.log(varianteId);
    // console.log(quantity);
    add_to_cart(varianteId, quantity);

  });
}